import {Component, Input} from '@angular/core';

@Component({
  templateUrl: './park-bypass-controls.html',
  selector: 'park-bypass-controls'
})

export class ParkBypassControlsComponent {
  @Input() public bypasses: any;
  @Input() public parkId: any;
  @Input() public id: any;
  @Input() public color: string;

  objectKeys = Object.keys;

  public getBypasses() {
    if (!this.isOld()) {
      const b = {};

      Object.keys(this.bypasses).forEach(id => {
        if ((typeof this.bypasses[id]) !== 'string') {
          b[id] = this.bypasses[id];
        }
      });

      return b;
    } else {
      return this.bypasses;
    }
  }

  public isOld() {
    let isOld = true;

    Object.keys(this.bypasses).forEach(id => {
      if ((typeof this.bypasses[id]) !== 'string') {
        isOld = false;
      }
    });

    return isOld;
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/controls/others/bypass/park-bypass-controls.component.ts